import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import validator from 'validator';
import { login, loginVerifyCode } from '../../../../services/AuthService';
import Utils from '../../../../utils';
import { CLIENT_LOCAL_STORE, SALT } from '../../../../configs/AppConfig';
import { encryptData } from '../../../../utils/crypto';
import Banchmark from "../../../../assets/Images/Banchmark.png";
import Bechtel from "../../../../assets/Images/bechtel.png";
import IKDRLogo from "../../../../assets/Images/IKDRCLogo.png";
import tstp from "../../../../assets/Images/tstp.png";
import sterling from "../../../../assets/Images/sterling.png";
import palsa from "../../../../assets/Images/palsa.png";

const GuestHeroSection = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isVerify, setIsVerify] = useState(false);
    const [userData, setUserData] = useState({});
    const [code, setCode] = useState('');

    const errorsObj = { email: '', password: '', code: '' };
    const [errors, setErrors] = useState(errorsObj);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (errors.email) setErrors(prev => ({ ...prev, email: '' }));
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        if (errors.password) setErrors(prev => ({ ...prev, password: '' }));
    };

    const handleCodeChange = (e) => {
        setCode(e.target.value);
        if (errors.code) setErrors(prev => ({ ...prev, code: '' }));
    };

    const handleLogin = (e) => {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };

        if (email === '') {
            errorObj.email = 'Email is required';
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = 'Please enter a valid email address';
            error = true;
        }

        if (password === '') {
            errorObj.password = 'Password is required';
            error = true;
        }

        setErrors(errorObj);
        if (error) return;

        setLoading(true);
        const obj = { email, password };

        login(obj)
            .then(response => {
                if (response.data.data.qr_code) {
                    setIsVerify(true);
                    setUserData(response.data.data);
                    toast.info('Please enter your 2FA code');
                } else {
                    const encryptedData = encryptData(response.data.data, SALT);
                    localStorage.setItem(CLIENT_LOCAL_STORE, encryptedData);
                    Utils.updateLastActivity();
                    toast.success('Login successful!');
                    navigate('/client-portal');
                }
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
            })
            .finally(() => setLoading(false));
    };

    const handleVerify = (e) => {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };

        if (!code) {
            errorObj.code = 'Verification code is required';
            error = true;
        }
        setErrors(errorObj);
        if (error) return;

        setLoading(true);
        const obj = {
            id: userData.id,
            company_login_id: userData.company_user_id,
            code
        };

        loginVerifyCode(obj)
            .then(() => {
                const encryptedData = encryptData(userData, SALT);
                localStorage.setItem(CLIENT_LOCAL_STORE, encryptedData);
                Utils.updateLastActivity();
                toast.success('Verification successful!');
                navigate('/client-portal');
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
            })
            .finally(() => setLoading(false));
    };

    return (
        <section className="hero-section">
            <div className="guest-container">
                <div className="row align-items-start g-4">
                    {/* Desktop Content */}
                    <div className="col-lg-12 col-xl-7 hero-content-wrapper desktop-content">
                        <div className="hero-content">
                            <h1 className="hero-heading">
                                <span className="text-primary-blue">{t('hero.heading')}</span><br />
                                <span className="text-black">{t('hero.subheading')}</span>
                            </h1>
                            <h2 className="hero-description">{t('hero.description')}</h2>
                            <div className="hero-buttons">
                                <button className="btn-demo" onClick={() => navigate('/sign-up')}>
                                    {t('hero.requestDemo')}
                                    <i className="bi bi-arrow-right"></i>
                                </button>
                            </div>

                            {/* Company Logos */}
                            <div className="company-logos-wrapper">
                                <div className="company-logos-slider">
                                    <div className="company-logos-track">
                                        <img src={Banchmark} alt="Banchmark" className="company-logo-img" />
                                        <img src={Bechtel} alt="Bechtel" className="company-logo-img" />
                                        <img src={palsa} alt="CBR" className="company-logo-img" />
                                        {/* <img src={Coldwell} alt="Coldwell" className="company-logo-img" /> */}
                                        <img src={IKDRLogo} alt="IKDRLogo" className="company-logo-img" />
                                        {/* <img src={ZROPDICElOGO} alt="ZROPDICElOGO" className="company-logo-img" /> */}
                                        <img src={sterling} alt="sterling" className="company-logo-img" />
                                        <img src={tstp} alt="tstp" className="company-logo-img" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Mobile Content */}
                    <div className="col-12 mobile-content">
                        <div className="mobile-hero-content">
                            <h1 className="hero-heading">
                                <span className="text-primary-blue">{t('hero.heading')}</span><br />
                                <span className="text-black">{t('hero.subheading')}</span>
                            </h1>
                            <h2 className="hero-description">{t('hero.description')}</h2>
            
                            <div className="hero-buttons">
                                <button className="btn-signup-res" onClick={() => navigate('/login')}>
                                    Start Free Trial
                                    <i className="bi bi-arrow-right"></i>
                                </button>
                                <button className="btn-demo" onClick={() => navigate('/sign-up')}>
                                    {t('hero.requestDemo')}
                                    <i className="bi bi-arrow-right"></i>
                                </button>
                            </div>

                            {/* Company Logos */}
                            <div className="company-logos-wrapper">
                                <div className="company-logos-slider">
                                    <div className="company-logos-track">
                                        <img src={Banchmark} alt="Banchmark" className="company-logo-img" />
                                        <img src={Bechtel} alt="Bechtel" className="company-logo-img" />
                                        <img src={palsa} alt="CBR" className="company-logo-img" />
                                        {/* <img src={Coldwell} alt="Coldwell" className="company-logo-img" /> */}
                                        <img src={IKDRLogo} alt="IKDRLogo" className="company-logo-img" />
                                        {/* <img src={ZROPDICElOGO} alt="ZROPDICElOGO" className="company-logo-img" /> */}
                                        <img src={sterling} alt="sterling" className="company-logo-img" />
                                        <img src={tstp} alt="tstp" className="company-logo-img" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Login Form */}
                    <div className="col-lg-12 col-xl-4 offset-xl-1 hero-login-wrapper">
                        <div className="signup-card-wrapper">
                            <div className="signup-card">
                                {isVerify ? (
                                    <>
                                        <h3 className="signup-title">{t('hero.twoFATitle')}</h3>
                                        <p className="verification-subtitle">{t('hero.twoFASubtitle')}</p>
                                        <form onSubmit={handleVerify} className="signup-form">
                                            <div className="form-group">
                                                <label htmlFor="code" className="form-label">{t('hero.codeLabel')}</label>
                                                <input
                                                    type="text"
                                                    className={`custom-input form-control ${errors.code ? 'error' : ''}`}
                                                    name="code"
                                                    id="code"
                                                    placeholder={t('hero.codePlaceholder')}
                                                    value={code}
                                                    onChange={handleCodeChange}
                                                    maxLength="6"
                                                />
                                                {errors.code && <div className="error-message">{errors.code}</div>}
                                            </div>
                                            <button type="submit" className="btn-signup" disabled={loading}>
                                                {loading ? t('hero.verifying') : t('hero.verifyButton')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn-back"
                                                onClick={() => {
                                                    setIsVerify(false);
                                                    setCode('');
                                                    setErrors(errorsObj);
                                                }}
                                            >
                                                <i className="bi bi-arrow-left"></i> {t('hero.backToLogin')}
                                            </button>
                                        </form>
                                    </>
                                ) : (
                                    <>
                                        <h3 className="signup-title">{t('hero.signInTitle')}</h3>
                                        <form onSubmit={handleLogin} className="signup-form">
                                            <div className="form-group">
                                                <label htmlFor="email" className="form-label">{t('hero.emailLabel')}</label>
                                                <input
                                                    type="text"
                                                    className={`custom-input form-control ${errors.email ? 'error' : ''}`}
                                                    name="email"
                                                    id="email"
                                                    placeholder={t('hero.emailPlaceholder')}
                                                    value={email}
                                                    onChange={handleEmailChange}
                                                    maxLength="50"
                                                />
                                                {errors.email && <div className="error-message">{errors.email}</div>}
                                            </div>

                                            <div className="form-group password-group position-relative">
                                                <label htmlFor="password" className="form-label">{t('hero.passwordLabel')}</label>
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className={`custom-input form-control ${errors.password ? 'error' : ''}`}
                                                    name="password"
                                                    id="password"
                                                    placeholder={t('hero.passwordPlaceholder')}
                                                    value={password}
                                                    onChange={handlePasswordChange}
                                                    maxLength="15"
                                                />
                                                <button
                                                    type="button"
                                                    className="password-toggle-btn"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                >
                                                    <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                                </button>
                                                {errors.password && <div className="error-message">{errors.password}</div>}

                                                {/* ✅ Forgot Password - aligned right under password field */}
                                                <div className="text-end mt-2">
                                                    <NavLink to="/forgot-password" className="forgot-password-link text-decoration-none">
                                                     {t('hero.forgotPassword')}
                                                    </NavLink>
                                                </div>
                                            </div>

                                            {/* Sign In Button */}
                                            <button type="submit" className="btn-signup" disabled={loading}>
                                                {loading ? t('hero.signingIn') : t('hero.signInButton')}
                                            </button>
                                            {/* 
                                            <div className="social-signin-section">
                                                <div className="social-buttons">
                                                    <button type="button" className="btn-social google">
                                                        <i className="bi bi-google"></i>
                                                    </button>
                                                    <button type="button" className="btn-social facebook">
                                                        <i className="bi bi-facebook"></i>
                                                    </button>
                                                    <button type="button" className="btn-social linkedin">
                                                        <i className="bi bi-linkedin"></i>
                                                    </button>
                                                    <button type="button" className="btn-social twitter">
                                                        <i className="bi bi-twitter-x"></i>
                                                    </button>
                                                </div>
                                            </div> */}
                                        </form>
                                    </>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GuestHeroSection;
